/* -----------------------------------------------------------------------------------------------------
  - Created: [31-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains Layout of the app
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useRef, useState } from 'react'
import './Layout.css'
import CompanyInfo from '../../Components/Header/CompanyInfo/CompanyInfo'
import Sidebar from '../../Components/SidebarComponent/Sidebar'
import Header from '../../Components/Header/Header'
import { Outlet, useNavigate } from 'react-router-dom';  // Import Outlet to render child routes
import { ErrorToast, SuccessToast } from '../../utils/toast'
import { removeAuthToken, removeUserData } from '../../utils/localStorage'
import { logoutUser } from '../../config/authApis'
import { setPrivileges } from '../../features/privileges/privilegesSlice'
import { useDispatch } from 'react-redux'
import useScreenSize from '../../utils/useScreenSize'
import { resetScheduleFilters } from '../../features/slices/scheduleFilterSlice'
import { resetWorkforceFilters } from '../../features/slices/workforceFilterSlice'
import { setPageTitle } from '../../utils/setPageTitle'

const Layout = () => {

    const dispatch = useDispatch();
    const { width, height } = useScreenSize();

    const [isSidebarOpen, setIsSidebarOpen] = useState(width >= 1024);
    const sidebarRef = useRef(null);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };


    //FOR UPDATE TH SIDEBAR WHEN WIDTH CHNAGES
    useEffect(() => {
        // Set initial sidebar state based on screen width
        setIsSidebarOpen(width >= 1024);

        const handleClickOutside = (event) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                width < 1024
            ) {
                setIsSidebarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [width]);

    const navigate = useNavigate()

    // Handle Logout logic
    const handleLogoutClick = async () => {
        try {
            const response = await logoutUser()
            if (response?.status === 200) { //when logout success
                const message = response?.data?.message
                SuccessToast(message)
                removeAuthToken()  // Reset local storage
                removeUserData()
                dispatch(setPrivileges([]));  // Reset Redux state
                dispatch(resetScheduleFilters());
                dispatch(resetWorkforceFilters());
                navigate(`/`)
                setPageTitle("") // Reset the page title
            } else {
                ErrorToast(`Something went wrong!`)
            }
        } catch (error) {
            console.log("error", error);

        }
    };

    return (
        <div className="layout-container">

            <div ref={sidebarRef} className={`sidebar-container ${!isSidebarOpen ? "closed" : "open"}`} style={{ zIndex: 1900 }}>
                <CompanyInfo toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <Sidebar handleLogoutClick={handleLogoutClick} toggleSidebar={toggleSidebar} />
            </div>
            <div className={`layout-content-container ${!isSidebarOpen ? "full-width" : ""}`}>
                <div className="header-fixed" >
                    <Header handleLogoutClick={handleLogoutClick} toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                </div>
                <div className="layout-content-scrollable">
                    <Outlet />
                </div>
            </div>
        </div>
    );


};

export default Layout;